module.exports = __webpack_public_path__ + "media/images/emblems/Boussens-coat_of_arms-9809eb526d01898eaf366357894cdff1.svg";